// ============================================
// Admin Layout
// ============================================

import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import InstallPrompt from '../../components/InstallPrompt';

export default function AdminLayout() {
  const { user, role, roles, activeRole, hasMultipleRoles, loading, signOut, switchRole } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Use activeRole for access control, fall back to legacy role
  const effectiveRole = activeRole || role;

  React.useEffect(() => {
    if (!loading && (!user || (effectiveRole !== 'superadmin' && effectiveRole !== 'admin'))) {
      navigate('/login', { state: { from: location }, replace: true });
    }
  }, [user, effectiveRole, loading, navigate, location]);

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  const handleSwitchToTherapist = async () => {
    try {
      await switchRole('therapist');
      navigate('/t');
    } catch (err) {
      console.error('Failed to switch role:', err);
    }
  };

  if (loading) {
    return <div className="loading-screen">Loading...</div>;
  }

  if (!user || (effectiveRole !== 'superadmin' && effectiveRole !== 'admin')) {
    return null;
  }

  return (
    <div className="admin-layout">
      <nav className="admin-nav">
        <div className="nav-brand">
          <Link to="/admin">Poker Massage</Link>
          <span className="badge">Admin</span>
        </div>
        <div className="nav-links">
          <Link to="/admin" className={location.pathname === '/admin' ? 'active' : ''}>
            Dashboard
          </Link>
          <Link to="/admin/events" className={location.pathname.includes('/events') ? 'active' : ''}>
            Events
          </Link>
          {effectiveRole === 'superadmin' && (
            <Link to="/admin/signups" className={location.pathname === '/admin/signups' ? 'active' : ''}>
              Signups
            </Link>
          )}
        </div>
        <div className="nav-user">
          {user.photoURL && (
            <img
              src={user.photoURL}
              alt=""
              className="nav-user-photo"
            />
          )}
          <span>{user.email}</span>
          {effectiveRole === 'superadmin' && <span className="badge superadmin">SuperAdmin</span>}
          {hasMultipleRoles && roles.includes('therapist') && (
            <button
              onClick={handleSwitchToTherapist}
              className="btn btn-sm"
              style={{ background: '#10b981', color: '#fff', marginRight: '0.5rem' }}
              title="Switch to Therapist view"
            >
              Switch to Therapist
            </button>
          )}
          <button onClick={handleSignOut} className="btn btn-sm">
            Sign Out
          </button>
        </div>
      </nav>
      <main className="admin-main">
        <Outlet />
      </main>

      <InstallPrompt variant="compact" />
    </div>
  );
}
